function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronDown, X } from "@ignite-analytics/icons";
import { inputBaseClasses } from "@mui/material/InputBase";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Error100Shadow, Primary100Shadow } from "../fundations/effects/focusRing";
import { getBackgroundToken, getBorderToken, getTextToken } from "../fundations/palette/colorTokens";
const checkboxSvgUrlContent = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4zNzM5IDQuMjkyODlDMTcuNzY0NSA0LjY4MzQyIDE3Ljc2NDUgNS4zMTY1OCAxNy4zNzM5IDUuNzA3MTFMOC4yMDcyNyAxNC44NzM4QzguMDE5NzMgMTUuMDYxMyA3Ljc2NTM4IDE1LjE2NjcgNy41MDAxNiAxNS4xNjY3QzcuMjM0OTUgMTUuMTY2NyA2Ljk4MDU5IDE1LjA2MTMgNi43OTMwNiAxNC44NzM4TDIuNjI2MzkgMTAuNzA3MUMyLjIzNTg3IDEwLjMxNjYgMi4yMzU4NyA5LjY4MzQyIDIuNjI2MzkgOS4yOTI4OUMzLjAxNjkxIDguOTAyMzcgMy42NTAwOCA4LjkwMjM3IDQuMDQwNiA5LjI5Mjg5TDcuNTAwMTYgMTIuNzUyNUwxNS45NTk3IDQuMjkyODlDMTYuMzUwMiAzLjkwMjM3IDE2Ljk4MzQgMy45MDIzNyAxNy4zNzM5IDQuMjkyODlaIiBmaWxsPSIjMDI4M0M1Ii8+Cjwvc3ZnPgoK";
export const TextField = {
    MuiInputLabel: {
        defaultProps: {
            shrink: true
        },
        styleOverrides: {
            root: ({ theme })=>_object_spread_props(_object_spread({
                    display: "block",
                    position: "relative",
                    transform: "none",
                    fontWeight: 500
                }, theme.typography.textSm), {
                    paddingBottom: theme.spacing(0.5),
                    color: `${getTextToken("textSecondary", theme)}`,
                    "&.Mui-focused": {
                        color: `${getTextToken("textSecondary", theme)}`
                    },
                    "& .MuiInputLabel-sizeLarge": _object_spread({}, theme.typography.textMd),
                    "& .Mui-error": {
                        color: `${getTextToken("textSecondary", theme)}`
                    }
                })
        }
    },
    MuiOutlinedInput: {
        variants: [
            {
                props: {
                    size: "small"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({}, theme.typography.textSm), {
                        [`.${outlinedInputClasses.input}`]: {
                            height: "1.25rem",
                            padding: theme.spacing(0.75, 1.5)
                        }
                    })
            },
            {
                props: {
                    size: "medium"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({}, theme.typography.textSm), {
                        [`.${outlinedInputClasses.input}`]: {
                            height: "1.25rem",
                            padding: theme.spacing(1.25, 1.75)
                        }
                    })
            },
            {
                props: {
                    size: "large"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({}, theme.typography.textMd), {
                        [`.${outlinedInputClasses.input}`]: {
                            height: "1.5rem",
                            padding: theme.spacing(1.5, 1.75)
                        }
                    })
            }
        ]
    },
    MuiTextField: {
        styleOverrides: {
            root: ({ theme })=>({
                    "& .MuiOutlinedInput-root": {
                        "&.Mui-error": {
                            "& fieldset": {
                                border: `1px solid ${getBorderToken("borderDestructiveError", theme)}`
                            },
                            "&:hover fieldset": {
                                border: `1px solid ${getBorderToken("borderDestructiveError", theme)}`
                            },
                            "&:hover fieldset.Mui-error": {
                                border: `1px solid ${getBorderToken("borderDestructiveError", theme)}`
                            },
                            "&.Mui-focused fieldset": {
                                border: `1px solid ${getBorderToken("borderDestructiveError", theme)}`,
                                boxShadow: Error100Shadow
                            }
                        },
                        "& fieldset": {
                            border: `1px solid ${getBorderToken("border300", theme)}`,
                            "& legend": {
                                display: "none"
                            },
                            top: 0
                        },
                        "&:hover fieldset": {
                            border: `1px solid ${getBorderToken("border300", theme)}`
                        },
                        "&:hover fieldset.Mui-error": {
                            border: `1px solid ${getBorderToken("borderDestructiveError", theme)}`
                        },
                        "&.Mui-focused fieldset": {
                            border: `1px solid ${getBorderToken("borderInteractive", theme)}`,
                            boxShadow: Primary100Shadow
                        }
                    }
                })
        }
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: ({ theme })=>_object_spread_props(_object_spread({}, theme.typography.textSm), {
                    color: `${getTextToken("textHelper", theme)}`,
                    margin: 0,
                    paddingTop: theme.spacing(0.5),
                    "& .Mui-error": {
                        color: `${getTextToken("textError", theme)}`
                    }
                })
        }
    },
    MuiSelect: {
        defaultProps: {
            IconComponent: ChevronDown
        },
        styleOverrides: {
            root: ({ theme })=>({
                    "& fieldset": {
                        border: `1px solid ${getBorderToken("border300", theme)}`,
                        "& legend": {
                            display: "none"
                        },
                        top: 0
                    },
                    "&.Mui-focused fieldset": {
                        border: `1px solid ${getBorderToken("borderInteractive", theme)}`,
                        boxShadow: Primary100Shadow
                    },
                    "&:hover": {
                        border: "none"
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: `1px solid ${getBorderToken("borderInteractive", theme)}`
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: `1px solid ${getBorderToken("border300", theme)}`
                    },
                    "& .MuiSvgIcon-root": {
                        width: "20px",
                        height: "20px",
                        top: "calc(50% - 10px)"
                    }
                })
        }
    },
    MuiAutocomplete: {
        defaultProps: {
            clearIcon: /*#__PURE__*/ _jsx(X, {}),
            popupIcon: /*#__PURE__*/ _jsx(ChevronDown, {})
        },
        styleOverrides: {
            inputRoot: ({ theme })=>({
                    minHeight: "40px",
                    padding: theme.spacing(1.25, 1.5),
                    gap: theme.spacing(0, 0.75),
                    "& .MuiChip-deleteIcon": {
                        width: "12px",
                        height: "12px"
                    }
                }),
            option: ({ theme })=>({
                    height: "40px",
                    py: theme.spacing(1.25),
                    "&[aria-selected='true']": {
                        backgroundColor: theme.palette.background.default
                    },
                    "&[aria-selected='true']:not([data-hide-check-icon='true'])::after": {
                        content: `url("${checkboxSvgUrlContent}")`,
                        width: "20px",
                        height: "20px",
                        display: "inline-block",
                        marginLeft: "auto"
                    }
                }),
            listbox: ({ theme })=>({
                    paddingTop: theme.spacing(0.5),
                    paddingBottom: theme.spacing(0.5)
                }),
            paper: ({ theme })=>({
                    marginTop: theme.spacing(1)
                }),
            root: ({ theme })=>({
                    "& fieldset": {
                        border: `1px solid ${getBorderToken("border300", theme)}`,
                        "& legend": {
                            display: "none"
                        },
                        top: 0
                    },
                    "&.Mui-focused fieldset": {
                        border: `1px solid ${getBorderToken("borderInteractive", theme)}`,
                        boxShadow: Primary100Shadow
                    },
                    "&:hover": {
                        border: "none"
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: `1px solid ${getBorderToken("borderInteractive", theme)}`
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: `1px solid ${getBorderToken("border300", theme)}`
                    },
                    "& .MuiSvgIcon-root": {
                        width: "20px",
                        height: "20px",
                        top: "calc(50% - 10px)",
                        color: `${getTextToken("textHelper", theme)}`
                    },
                    "& .MuiIconButton-root": {
                        width: "auto",
                        height: "auto"
                    }
                })
        }
    },
    MuiInputBase: {
        styleOverrides: {
            root: ({ theme })=>({
                    background: getBackgroundToken("backgroundPrimaryBase", theme),
                    [`&.${inputBaseClasses.multiline}`]: {
                        "& textarea": {
                            padding: theme.spacing(1.25, 1.5),
                            borderRadius: "8px",
                            border: `1px solid ${getBorderToken("border300", theme)}`,
                            "&:hover": {
                                border: `1px solid ${getBorderToken("border300", theme)}`
                            },
                            "&:focus": {
                                border: `1px solid ${getBorderToken("borderInteractive", theme)}`,
                                boxShadow: Primary100Shadow
                            },
                            "&:focus-visible": {
                                outline: 0
                            }
                        },
                        "& fieldset": {
                            display: "none"
                        }
                    }
                })
        }
    }
};

//# sourceMappingURL=FormFields.js.map